import {
  assertNever,
  BlackjackListener,
  ChipDenomination,
  EventQueue,
  UiButtonType,
} from 'game-logic';
import { BetController } from './bet-controller';
import { BlackjackGameRunner } from '../../model/blackjack-game-runner';
import { InterfaceEvents } from '../services/game-services';

export class InterfaceController {
  public get currentBetChips(): ReadonlyArray<ChipDenomination> {
    return this.betController.currentBetChips;
  }

  private readonly betController: BetController;

  constructor(
    private blackjackGameRunner: BlackjackGameRunner,
    interfaceEventQueue: EventQueue<InterfaceEvents>,
    gameListener: BlackjackListener,
  ) {
    this.betController = new BetController(blackjackGameRunner, interfaceEventQueue, gameListener);
  }

  public increaseCurrentBet(chip: ChipDenomination): void {
    this.betController.increaseCurrentBet(chip);
  }

  public clearCurrentBet(): void {
    this.betController.clearCurrentBet();
  }

  public uiButtonTapped(uiButton: UiButtonType): void {
    switch (uiButton) {
      case UiButtonType.Clear:
        this.betController.clearCurrentBet();
        break;
      case UiButtonType.AllIn:
        this.betController.betAllIn();
        break;
      case UiButtonType.Deal:
        this.blackjackGameRunner.currentGame?.dealDeck(this.betController.totalBetAmount);
        break;
      case UiButtonType.Stand:
        this.blackjackGameRunner.currentGame?.playerStandDeck();
        break;
      case UiButtonType.Double:
        this.blackjackGameRunner.currentGame?.playerDoubleDeck();
        break;
      case UiButtonType.Split:
        this.blackjackGameRunner.currentGame?.playerSplitDeck();
        break;
      case UiButtonType.Hit:
        this.blackjackGameRunner.currentGame?.playerHitDeck();
        break;
      case UiButtonType.Continue:
        this.blackjackGameRunner.currentGame?.continueRound(false);
        break;
      default:
        assertNever(uiButton, `Unknown ui button type`);
    }
  }
}
